/* tslint:disable */
/* eslint-disable */
import { PhaseDisplayModel as AceXFoundPortalCoreCaqModelsPhaseDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/phase-display-model';
import { GlobalEnumsAceBewertung as AceXFoundPortalCoreEntitiesGlobalEnumsAceBewertung } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-bewertung';
import { GlobalEnumsAcePrioritaet as AceXFoundPortalCoreEntitiesGlobalEnumsAcePrioritaet } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-prioritaet';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';
import { AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode as AceXFoundPortalCoreEntitiesAceGutachtenAceGutachtenEnumsAceGutachtenStatuscode } from '../../../../../../ace/xFound/Portal/Core/Entities/ace-gutachten-ace-gutachten-enums-ace-gutachten-statuscode';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { PhaseDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup } from '@/api/model-index';

export interface IGutachtenListDisplayModel {
  anfrageBeschreibung?: null | string;
  anfrageNummer?: null | string;
  anfrageTitel?: null | string;
  antragstellerName?: null | string;
  ausschreibungsName?: null | string;
  befangenheit?: null | boolean;
  begruendungBefangenheit?: null | string;
  bewertung?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBewertung;
  foerdersumme?: null | number;
  gutachtenAbgegebenAm?: null | string;
  gutachtenId?: string;
  gutachtenPhase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  prioritaet?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePrioritaet;
  scope?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  statuscode?: AceXFoundPortalCoreEntitiesAceGutachtenAceGutachtenEnumsAceGutachtenStatuscode;
}
export class GutachtenListDisplayModel extends BaseModel implements IGutachtenListDisplayModel {
  anfrageBeschreibung?: null | string;
  anfrageNummer?: null | string;
  anfrageTitel?: null | string;
  antragstellerName?: null | string;
  ausschreibungsName?: null | string;
  befangenheit?: null | boolean;
  begruendungBefangenheit?: null | string;
  bewertung?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBewertung;
  foerdersumme?: null | number;
  gutachtenAbgegebenAm?: null | string;
  gutachtenId?: string;
  gutachtenPhase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  prioritaet?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePrioritaet;
  scope?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  statuscode?: AceXFoundPortalCoreEntitiesAceGutachtenAceGutachtenEnumsAceGutachtenStatuscode;
}
class BaseGutachtenListDisplayModelFormGroup extends FormGroup {
  private static _instance: GutachtenListDisplayModelFormGroup;
  
  public static get Instance(): GutachtenListDisplayModelFormGroup {
    this._instance = new GutachtenListDisplayModelFormGroup({
      anfrageBeschreibung: new FormControl(null),
      anfrageNummer: new FormControl(null),
      anfrageTitel: new FormControl(null),
      antragstellerName: new FormControl(null),
      ausschreibungsName: new FormControl(null),
      befangenheit: new FormControl(null),
      begruendungBefangenheit: new FormControl(null),
      bewertung: new FormControl(null),
      foerdersumme: new FormControl(null),
      gutachtenAbgegebenAm: new FormControl(null),
      gutachtenId: new FormControl(null),
      gutachtenPhase: AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup.Instance,
      prioritaet: new FormControl(null),
      scope: new FormControl(null),
      statuscode: new FormControl(null),
    });

    return this._instance;
  }
}


export class GutachtenListDisplayModelFormGroup extends BaseGutachtenListDisplayModelFormGroup {
  public get AnfrageBeschreibung(): FormControl {
    return this.controls["anfrageBeschreibung"] as FormControl;
  }
  public get AnfrageNummer(): FormControl {
    return this.controls["anfrageNummer"] as FormControl;
  }
  public get AnfrageTitel(): FormControl {
    return this.controls["anfrageTitel"] as FormControl;
  }
  public get AntragstellerName(): FormControl {
    return this.controls["antragstellerName"] as FormControl;
  }
  public get AusschreibungsName(): FormControl {
    return this.controls["ausschreibungsName"] as FormControl;
  }
  public get Befangenheit(): FormControl {
    return this.controls["befangenheit"] as FormControl;
  }
  public get BegruendungBefangenheit(): FormControl {
    return this.controls["begruendungBefangenheit"] as FormControl;
  }
  public get Bewertung(): FormControl {
    return this.controls["bewertung"] as FormControl;
  }
  public get Foerdersumme(): FormControl {
    return this.controls["foerdersumme"] as FormControl;
  }
  public get GutachtenAbgegebenAm(): FormControl {
    return this.controls["gutachtenAbgegebenAm"] as FormControl;
  }
  public get GutachtenId(): FormControl {
    return this.controls["gutachtenId"] as FormControl;
  }
  public get GutachtenPhase(): AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup {
    return this.controls["gutachtenPhase"] as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup;
  }
  public get Prioritaet(): FormControl {
    return this.controls["prioritaet"] as FormControl;
  }
  public get Scope(): FormControl {
    return this.controls["scope"] as FormControl;
  }
  public get Statuscode(): FormControl {
    return this.controls["statuscode"] as FormControl;
  }
  

}

export module GutachtenListDisplayModelForm
  {
    export class FormFields
    {
      static _anfrageBeschreibung: string = "anfrageBeschreibung";
      static _anfrageNummer: string = "anfrageNummer";
      static _anfrageTitel: string = "anfrageTitel";
      static _antragstellerName: string = "antragstellerName";
      static _ausschreibungsName: string = "ausschreibungsName";
      static _befangenheit: string = "befangenheit";
      static _begruendungBefangenheit: string = "begruendungBefangenheit";
      static _bewertung: string = "bewertung";
      static _foerdersumme: string = "foerdersumme";
      static _gutachtenAbgegebenAm: string = "gutachtenAbgegebenAm";
      static _gutachtenId: string = "gutachtenId";
      static _gutachtenPhase: string = "gutachtenPhase";
      static _prioritaet: string = "prioritaet";
      static _scope: string = "scope";
      static _statuscode: string = "statuscode";
    }
  }

